export const CHAT_KEY = "chatEntries";
export const MAX_CHAT_ENTRIES = 25;

export const CHAT_ENTRY_TYPES = {
  UNKNOWN: "UNKNOWN",
  DICE_ROLL: "DICE_ROLL",
  TEXT: "TEXT",
  LIST_ITEM: "LIST_ITEM",
  COMPENDIUM: "COMPENDIUM",
  IMAGE: "IMAGE",
  PRESSURE_GAUGE: "PRESSURE_GAUGE",
  SCRUTINY: "SCRUTINY",
  MYSTERY: "MYSTERY",
  MOOD: "MOOD",
  JOURNEY: "JOURNEY",
};
